export default defineNuxtRouteMiddleware((to) => {
  const config = useRuntimeConfig()

  // 檢測帶 t 的情況 → 導航到 processing 頁面
  if (to.path === '/home' && typeof to.query.t === 'string' && to.query.t.length > 0) {
    return navigateTo(`/auth/processing?t=${encodeURIComponent(to.query.t)}`)
  }

  const excludedRoute = ['/signup', '/forgetpassword', '/forgetPassword' , '/resetPassword', '/resetpassword', '/auth/processing', '/guest', '/chat']

  // Server side - 基本認證檢查
  if (import.meta.server) {
    // 開發環境跳過認證檢查
    if (import.meta.dev) {
      return
    }
    const isPublic = excludedRoute.includes(to.path)
    console.log();
    if (!isPublic) {
      const tokenCookie = useCookie('token')
      const secureTokenCookie = useCookie('token_secure')

      const hasToken = !!(tokenCookie.value || secureTokenCookie.value)

      if (!hasToken) {
        return navigateTo(config.public.GSNurl, { external: true })
      }
    }
  }

  // Client side - 基本路由保護
  if (import.meta.client) {
    // 開發環境跳過認證檢查
    if (import.meta.dev) {
      return
    }
    const isPublic = excludedRoute.includes(to.path)

    if (!isPublic) {
      const cookieToken = useCookie('token')

      if (!cookieToken.value) {
        return navigateTo(config.public.GSNurl, { external: true })
      }
    }
  }
})